import { InternalApiDataUploadError, InternalApiDataUploadErrorNameEnum } from '../api-internal';

export const errorMessage = (errorGroup: Array<InternalApiDataUploadError>) => {
  const pluralizedIfNeeded = (word: string) => {
    if (errorGroup.length === 1) return word;
    if (word === 'is') return 'are';
    if (word === 'value on row') return 'values on multiple rows, including rows';
  };

  const rowNumbersWithValues = () =>
    errorGroup.map((error) => (error.actualValue ? `${error.row} ("${error.actualValue}")` : error.row)).join(', ');

  const rowNumbers = () => errorGroup.map((error) => error.row).join(', ');

  const error = errorGroup[0];
  if (error.name === InternalApiDataUploadErrorNameEnum.A_NUMBER_EXPECTED) {
    return `Field "${error.field}" has invalid ${pluralizedIfNeeded('value on row')} ${rowNumbersWithValues()}`;
  }

  if (error.name === InternalApiDataUploadErrorNameEnum.INVALID_DATE_FORMAT)
    return `An invalid date format has been defined for field "${error.field}" ("${error.expectedFormat}")`;

  if (error.name === InternalApiDataUploadErrorNameEnum.INVALID_DATE_VALUE)
    return `Field "${error.field}" has invalid ${pluralizedIfNeeded(
      'value on row'
    )} ${rowNumbersWithValues()}. Expected a date with format "${error.expectedFormat || 'yyyy-MM-dd'}"`;

  if (error.name === InternalApiDataUploadErrorNameEnum.MANDATORY_FIELD_VALUE_MISSING)
    return `Mandatory field "${error.field}" is missing ${pluralizedIfNeeded('value on row')} ${rowNumbers()}`;

  if (error.name === InternalApiDataUploadErrorNameEnum.INVALID_SHAPE) return error.message.replace(/record/g, 'row');

  if (error.name === InternalApiDataUploadErrorNameEnum.INVALID_DATETIME_VALUE)
    return `Field "${error.field}" has invalid ${pluralizedIfNeeded(
      'value on row'
    )} ${rowNumbersWithValues()}. Expected a timestamp with full date and time including seconds.`;

  return error.message;
};
